export default __webpack_public_path__ + "static/media/note-grey.4e79bd78.svg";